<template>
  <div>
    <Back :backText="$t('Pick_your_level')" @goBackRoute="goBackRoute"></Back>
    <div class="price-form">
      <div class="title">{{ $t('discounted_price') }}</div>
      <div class="desc" v-if="showPriceDesc">{{ $t('price_desc') }}</div>
      <div class="list-box" style="background: #dce7da; padding: 35px 42px">
        <div style="width: 124px; margin-bottom: 35px">
          <img src="@/assets/images/home/hsk.png" />
        </div>
        <el-table
          :data="hskTableData"
          :cell-style="setHskCellStyle"
          :header-cell-style="setHskHeaderCellStyle"
        >
          <el-table-column prop="no_test" :label="$t('no_test')"> </el-table-column>
          <el-table-column prop="level1" :label="$t('the_level') + '1'"> </el-table-column>
          <el-table-column prop="level2" :label="$t('the_level') + '2'"> </el-table-column>
          <el-table-column prop="level3" :label="$t('the_level') + '3'"> </el-table-column>
          <el-table-column prop="level4" :label="$t('the_level') + '4'"> </el-table-column>
          <el-table-column prop="level5" :label="$t('the_level') + '5'"> </el-table-column>
          <el-table-column prop="level6" :label="$t('the_level') + '6'"> </el-table-column>
          <el-table-column prop="level7" :label="$t('the_level') + '7-9'"> </el-table-column>
        </el-table>
      </div>
      <div class="list-box" style="background: #dce7da; padding: 35px 42px">
        <div style="width: 124px; margin-bottom: 35px">
          <img src="@/assets/images/home/hskk.png" />
        </div>
        <el-table
          :data="hskkTableData"
          :cell-style="setHskkCellStyle"
          :header-cell-style="setHskkHeaderCellStyle"
        >
          <el-table-column prop="no_test" :label="$t('no_test')"> </el-table-column>
          <el-table-column prop="level1" :label="$t('the_level') + '1'"> </el-table-column>
          <el-table-column prop="level2" :label="$t('the_level') + '2'"> </el-table-column>
          <el-table-column prop="level3" :label="$t('the_level') + '3'"> </el-table-column>
        </el-table>
      </div>
      <div class="list-box" style="background: #f4e2d4; padding: 35px 42px">
        <div style="width: 102px; margin-bottom: 35px">
          <img src="@/assets/images/home/yct.png" />
        </div>
        <el-table
          :data="yctTableData"
          :cell-style="setYctCellStyle"
          :header-cell-style="setYctHeaderCellStyle"
        >
          <el-table-column prop="no_test" :label="$t('no_test')"> </el-table-column>
          <el-table-column prop="level1" :label="$t('the_level') + '1'"> </el-table-column>
          <el-table-column prop="level2" :label="$t('the_level') + '2'"> </el-table-column>
          <el-table-column prop="level3" :label="$t('the_level') + '3'"> </el-table-column>
          <el-table-column prop="level4" :label="$t('the_level') + '4'"> </el-table-column>
        </el-table>
      </div>
      <div ref="desc" class="desc" v-html="$t('price_contact_us')"></div>
    </div>
  </div>
</template>
<script>
import Back from '@/components/common/Back.vue'
import { getCodesPriceList } from '@/serves/api/useCode'

export default {
  name: 'priceForm',
  components: {
    Back,
  },
  data() {
    return {
      hskTableData: [
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
          level5: '-',
          level6: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
          level5: '-',
          level6: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
          level5: '-',
          level6: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
          level5: '-',
          level6: '-',
        },
      ],
      hskkTableData: [
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
        },
      ],
      yctTableData: [
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
        },
        {
          no_test: '-',
          level1: '-',
          level2: '-',
          level3: '-',
          level4: '-',
        },
      ],
    }
  },
  // TODO：直接使用默认值 不使用 initDefaultData
  computed: {
    showPriceDesc() {
      if (this.hskTableData.length == 1 || this.hskkTableData.length == 1 || this.yctTableData.length == 1) {
        return false
      }
      return true
    },
  },
  created() {},
  mounted() {
    this.getDiscountPrice()
    this.addTextClick()
  },
  methods: {
    /** 前往选择考试等级页面 */
    goBackRoute() {
      this.$router.replace({
        name: 'ChooseLevel',
      })
    },
    // 获取折扣信息
    getDiscountPrice() {
      getCodesPriceList()
        .then((res) => {
          console.log('兑换码列表', res?.data)
          let array = res?.data
          if (!array) {
            // 没有配置相关数据
            this.$message({ type: 'error', message: '产品列表不存在' })
            return
          }
          for (let i = 0; i < array.length; i++) {
            const data = array[i]
            if (data.type_name == 'HSK') {
              this.hskTableData = this.parsePriceData(data?.level_products)
            } else if (data.type_name == 'HSKK') {
              this.hskkTableData = this.parsePriceData(data?.level_products)
            } else if (data.type_name == 'YCT') {
              this.yctTableData = this.parsePriceData(data?.level_products)
            } else {
              console.log('存在的其他数据', data)
            }
          }
        })
        .catch((err) => {
          console.log('兑换码列表获取失败', err)
          this.$message({ type: 'error', message: err })
        })
    },
    parsePriceData(data) {
      let arr = []
      for (let i = 0; i < data.length; i++) {
        let col = data[i].products
        if (!col) {
          col = new Array(4)
        }
        for (let j = 0; j < col.length; j++) {
          const row = col[j]
          if (!row) {
            if (!arr[j]) {
              arr[j] = { no_test: '-' }
            }
            arr[j]['level' + (i + 1)] = '-'
          } else {
            if (!arr[j]) {
              arr[j] = {
                no_test: row.item_count + (row.discount ? ' (-' + row.discount + ')' : ''),
              }
            }
            arr[j]['level' + (i + 1)] = row.currency + ' ' + row.unit_price / row.currency_base
          }
          // console.log('level' + (i + 1), arr[j]['level' + (i + 1)])
        }
      }
      // console.log(arr)
      return arr
    },
    addTextClick() {
      let nodes = this.$refs.desc.children
      for (let i = 0; i < nodes.length; i++) {
        const element = nodes[i]
        if (element.localName === 'span') {
          // console.log(element)
          element.addEventListener('click', () => {
            // this.onClickLogin()
            console.log('联系我们！！！')
            this.$router.push('/feedback')
          })
          break
        }
      }
    },
    setHskCellStyle(row) {
      let sty = this.getCellStyle(row, 'hsk', false)
      return sty
    },
    setHskkCellStyle(row) {
      let sty = this.getCellStyle(row, 'hskk', false)
      return sty
    },
    setYctCellStyle(row) {
      let sty = this.getCellStyle(row, 'yct', false)
      return sty
    },
    setHskHeaderCellStyle(row) {
      let sty = this.getCellStyle(row, 'hsk', true)
      return sty
    },
    setHskkHeaderCellStyle(row) {
      let sty = this.getCellStyle(row, 'hskk', true)
      return sty
    },
    setYctHeaderCellStyle(row) {
      let sty = this.getCellStyle(row, 'yct', true)
      return sty
    },
    /**
     * 设置表格单元格样式
     * @param {*} row 行单元格数据
     * @param {*} type_name 区分是hsk还是yct
     * @param {*} isHeader 是否是表头
     */
    getCellStyle(row, type_name, isHeader) {
      let styleStr = ''
      if (row.columnIndex == 0) {
        if (isHeader) {
          styleStr = 'background: #EFEFF1; color: #B5B5BE;'
        } else {
          styleStr = 'color: #696974; font-size: 17px; text-align: left;'
        }
        styleStr += 'padding-left:15px;'
      } else {
        if (isHeader) {
          if (type_name == 'hsk') {
            styleStr = 'background: #4d8346; color: white;'
          } else if (type_name == 'hskk') {
            styleStr = 'background: #4d8346; color: white;'
          } else {
            styleStr = 'background: #C97025; color: white;'
          }
        } else {
          styleStr =
            'color: #696974; border: 1px solid #ECECEC; border-width: 1px 0 0 1px; font-size: 14px; font-weight: 400;'
        }
        styleStr += 'text-align: center;'
      }
      styleStr += 'height: 55px;'
      return styleStr
    },
  },
}
</script>
<style scoped lang="scss">
.price-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    color: #000000;
    font-family: Inter;
    font-size: 32px;
    font-weight: 700;
    line-height: 39px;
    letter-spacing: 0em;
    text-align: center;
    margin-bottom: 20px;
  }
  .desc {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    color: #000000;
    margin-bottom: 20px;
  }
  .list-box {
    width: 100%;
    min-width: 1197px;
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 50px 100px;
    margin-bottom: 32px;
  }
}

::v-deep .el-table {
  // border-bottom: 1px solid #000;
  // border-right: 1px solid #000;
  font-size: 14px;
  font-weight: 700;
}
</style>
